module.exports = "img/flags/PY.d2261c0.png";